import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ListChecks, ArrowRight } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TasksDashboardPanel = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/tasks/summary`, { withCredentials: true })
      .then(r => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (!rows) return null;
  const rank = (p) => (p.total === 0 ? 0 : p.done < p.total ? 1 : 2);
  const sorted = [...rows].sort((a, b) => rank(a) - rank(b));

  return (
    <div className="bg-white p-6 rounded-lg border border-stone-200" data-testid="tasks-dashboard-panel">
      <div className="flex items-center gap-2 mb-4">
        <ListChecks className="w-5 h-5 text-amber-700" strokeWidth={1.5} />
        <h2 className="text-xl font-semibold text-stone-900" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Next up on active projects</h2>
      </div>
      {sorted.length === 0 && <p className="text-sm text-stone-500">No active projects.</p>}
      <div className="divide-y divide-stone-100">
        {sorted.map(p => (
          <button key={p.project_id} onClick={() => navigate(`/admin/projects/${p.project_id}/tasks`)} data-testid={`tasks-panel-project-${p.project_id}`}
            className="group w-full text-left py-3 flex flex-col md:flex-row md:items-center gap-3 hover:bg-stone-50 -mx-2 px-2 rounded transition-colors">
            <div className="md:w-56 shrink-0">
              <p className="text-sm font-medium text-stone-900">{p.project_name}</p>
              {p.total > 0 ? (
                <div className="flex items-center gap-2 mt-1.5">
                  <Progress value={(p.done / p.total) * 100} className="h-1.5 flex-1" />
                  <span className="text-[11px] text-stone-500 tabular-nums">{p.done}/{p.total}</span>
                </div>
              ) : <p className="text-[11px] text-amber-800 mt-1">No checklist yet — tap to load</p>}
            </div>
            <div className="flex-1 flex flex-wrap gap-1.5">
              {p.next_up.map(t => (
                <span key={t.task_id} className="text-[11px] bg-amber-50 text-amber-900 border border-amber-200 rounded-full px-2.5 py-0.5">{t.title}</span>
              ))}
              {p.ready_count > p.next_up.length && <span className="text-[11px] text-stone-500 px-1 py-0.5">+{p.ready_count - p.next_up.length} more</span>}
              {p.total > 0 && p.done === p.total && <span className="text-[11px] text-lime-800">All tasks done</span>}
            </div>
            <ArrowRight className="hidden md:block w-4 h-4 text-stone-300 group-hover:text-stone-700 transition-colors" />
          </button>
        ))}
      </div>
    </div>
  );
};
